import { render } from "./cloudwatch.vue?vue&type=template&id=15eda68c"
import script from "./cloudwatch.vue?vue&type=script&lang=js"
export * from "./cloudwatch.vue?vue&type=script&lang=js"

import "./cloudwatch.vue?vue&type=style&index=0&id=15eda68c&lang=css"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__